import React from 'react';
import { BarChart } from '../../../../ui-components/data-viz-ui/charts/bar-chart/BarChart';
import { TimePeriodSegmentedBarChartUiComponentProps } from './types';

export const TimePeriodSegmentedBarChartUiComponent = (
  props: TimePeriodSegmentedBarChartUiComponentProps
) => {
  return <BarChart {...props} />;
};
